import { TabPanel } from "react-tabs";
import { LandlordContainer } from "../../components/company/landlord-container";

export const LandLordsTab = (showLandlordDelete, companyData) => {
    return (<TabPanel>
        <div className='mb-2'>
            <button type="button" className="btn btn-primary" data-bs-toggle="dropdown">
                Action&nbsp;&nbsp;<span className="caret"></span>
            </button>
            <div className="dropdown-menu">
                <div className='dropdown-item link-like-div'><i className='fa fa-plus fa-lg'></i>&nbsp;&nbsp;Add Landlord</div>
                <div className='dropdown-item link-like-div'><i className='fa fa-trash fa-lg'></i>&nbsp;&nbsp;{`${showLandlordDelete ? 'Cancel Delete' : 'Delete Landlords'}`}</div>
                {showLandlordDelete &&
                    <div className='dropdown-item link-like-div'><i className='fa fa-trash fa-lg'></i>&nbsp;&nbsp;Delete Selected Landlords</div>}
                <div className="dropdown-divider"></div>
                <div className='dropdown-item link-like-div'><i className='fa fa-cog fa-lg'></i>&nbsp;&nbsp;Something worth dividing</div>
            </div>
        </div>
        <LandlordContainer companies={[companyData]} />
    </TabPanel>);
};